// extracted by mini-css-extract-plugin
export default {"root":"IconSocialMediaLinkedIn_root__6dJCv"};